<template>
  <div class="section">
    <div class="container">
      <h1>Purchase log</h1>
      <div class="columns">
        <div class="column is-3">
          <b-field label="Start date">
            <b-datepicker v-model="dates.start" placeholder="Start Period" icon="calendar-day"></b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field label="End date">
            <b-datepicker v-model="dates.end" placeholder="End Period" icon="calendar-day"></b-datepicker>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-3">
          <b-input type="text" v-model="filter" placeholder="Filter"></b-input>
        </div>
      </div>
      <div class="breathe">
        <button @click="GetReport()" class="button is-primary level-item" v-bind:class="{'is-loading': loading}">Get report</button>
      </div>
      <br />
      <div class="columns">
        <div class="column is-12" v-if="rows.length > 0">
          <b-table :data="Results"
                   :loading="loading"
                   paginated
                   :mobile-cards="true"
                   pagination-size="is-small"
                   :pagination-simple="true"
                   per-page="20"
                   default-sort-direction="desc"
                   default-sort="PurchasedOn">
            <b-table-column field="Name" label="Product" sortable v-slot="props">
              <span>{{props.row.Name}}</span>
            </b-table-column>
            <b-table-column field="Price" label="Price" sortable v-slot="props">
              <span>{{props.row.Price | currency('$')}}</span>
            </b-table-column>
            <b-table-column field="PurchasedOn" label="Purchased On" sortable v-slot="props">
              <span>{{props.row.PurchasedOn | utc | moment('MM/DD/YYYY')}}</span>
            </b-table-column>
            <b-table-column field="User" label="Purchased By" sortable v-slot="props">
              <span>{{props.row.User}}</span>
            </b-table-column>
            <b-table-column field="" label="" sortable v-slot="props">
              <span v-if="props.row.TransactionId">
                <div v-show="props.row.Refunds > 0">
                  Refunded: {{props.row.Refunds | currency('$')}}
                </div>
                <button class="button is-primary" :class="{'is-loading': props.row.refunding}" @click="Refund(props.row)">Refund</button>
              </span>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        loading: false,
        dates: {},
        rows: [],
        filter: ""
      }
    },
    computed: {
      Results() {
        var self = this;
        return this.rows.filter(row => {
          if (self.filter == "")
            return true;
          else {
            return row.Name.indexOf(self.filter) >= 0 || self.$options.filters.currency(row.Price, '$').indexOf(self.filter) >= 0 || self.$moment(row.PurchasedOn).format('MM/d/YYYY').indexOf(self.filter) >= 0 || row.User.indexOf(self.filter) >= 0;
          }
        });
      }
    },
    methods: {
      Refund(purchase) {
        if (confirm("This will fully refund this purchase and unsubscribe from the service. Are you sure you want to continue.")) {
          purchase.refunding = true;
          this.$http.get("/api/payment/refund/" + purchase.TransactionId).then(resp => {
            purchase.refunding = false;
            purchase.Refunds = purchase.Price
            this.$buefy.toast.open({
              message: "Success! This purchase has been refunded.",
              type: "is-success"
            });
          }).catch(resp => {
            purchase.refunding = false;
            this.$buefy.toast.open({
              message: "Unable to give refund.",
              type: "is-danger"
            });
          });
        }
      },
      GetReport() {
        this.loading = true;

        this.$http.post("/api/report/purchase", { dates: this.dates })
          .then(resp => {
            this.rows = resp.data;
            this.loading = false;
          }).catch(resp => {
            this.loading = false;
            this.$buefy.toast.open({
              message: "A problem occurred while running the report.",
              type: "is-danger"
            });
          });
      }
    },
    created() {
      this.dates.end = new Date();
      this.dates.start = new Date();
      this.dates.start.setDate(this.dates.start.getDate() - 30);

      this.GetReport();
    }
  }
</script>
